var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { getMiniCardDetailsParams } from "../../../../helpers";
import * as RenderMethods from "./RenderMethods";
let MiniEventCard = class MiniEventCard extends React.Component {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);
        this.renderMarkets = RenderMethods.renderMiniMarkets;
        this.renderCardDetails = RenderMethods.renderMiniCardDetails;
        this.getMiniCardDetailsParams = getMiniCardDetailsParams;
        this.cardTypeClass = "";
        this.componentPrefix = "mini-ev-card";
        this.buttonsHolderClass = `rj-ev-list__${this.componentPrefix}__buttons-holder`;
    }
    setClasses() {
        const isSelected = this.props.event.isSelected
            ? `rj-ev-list__${this.componentPrefix}--selected`
            : "";
        const inKickOff = this.props.event.isInKickOffState
            ? `rj-ev-list__${this.componentPrefix}--in-kick-off`
            : "";
        const hideGameState = this.props.hideGameState
            ? `rj-ev-list__${this.componentPrefix}--game-state-hidden`
            : "";
        return `rj-ev-list__${this.componentPrefix} ${this.cardTypeClass} ${isSelected} ${inKickOff} ${hideGameState}`;
    }
    render() {
        return (React.createElement("div", { className: this.setClasses(), "data-uat": `div-ev-list-${this.componentPrefix}` },
            React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__inner`, "data-uat": `div-ev-list-${this.componentPrefix}-inner` },
                this.renderCardDetails(this.getMiniCardDetailsParams(this.props), this.componentPrefix),
                this.props.showOddBtns && this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix))));
    }
};
MiniEventCard = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], MiniEventCard);
export { MiniEventCard };
//# sourceMappingURL=MiniEventCard.js.map